<template>
<div class="grid grid__container" :style="{ width: cw + 'px' }">
                <slot>grid</slot>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'grid-container',
  computed: {
    ...mapGetters([
      'cw',
    ]),
  },
};
</script>
